import { ApiResponse, ApiStatus } from './api.models';
import { Observable, of } from 'rxjs';

import { ApiRequestType } from 'src/app/shared/enums/api.enums';
import { catchError } from 'rxjs/operators';
import { toString } from 'lodash-es';

/**
 * The API action interface
 */
export interface ApiAction {
	/**
	 * The request type being made or receiving.
	 */
	requestType: string;
}

/**
 * Used as a pipe when sending an api request to catch any sort of errors that may happen.
 */
export function catchApiError<T>(): (err?: any) => Observable<ApiResponse<T>> {
	return catchError((err) =>
		of({
			SERVICE: {
				status: ApiStatus.FAILED,
				error_msg: toString(err),
			},
		} as ApiResponse<T>)
	);
}

/**
 * Filters effects for the
 * @param requestType The request type to filter by
 */
export function responseRequestType(requestType: string): (a) => boolean {
	return (action) => action.requestType === requestType;
}

/**
 * Find out if the action is of a specific type of request.
 * @param action The action to check
 * @param requestType The request type to check
 */
export function isApi(action: ApiAction, requestType: ApiRequestType): boolean {
	return action.requestType === requestType;
}

/**
 * Find out if the response is OK by checking the status
 * @param status staus of the api call
 */
export function isResponseOK(status: string): boolean {
	return status === ApiStatus.OK;
}
